@if (loadingService.loading()) {
<div class="top-loader">
  <div class="top-loader-bar"></div>
</div>
}